import React from "react";
// import SearchIcon from "@mui/icons-material/Search";
import { ToastContainer } from "react-toastify";
import { useUserTheme } from "src/shared/utils/useUserTheme";

interface SearchFieldProps {
  searchTerm: string;
  handleSearch: (value: string) => void;
}

const SearchField: React.FC<SearchFieldProps> = ({
  searchTerm,
  handleSearch,
}) => {
  const { fontClass, borderHighlight } = useUserTheme();

  return (
    <div className={`2xl:order-none xl:order-4 xl:col-span-2 lg:order-4 lg:col-span-1 md:order-4 md:col-span-2 w-full sm:w-[300px] lg:w-[400px] ${fontClass}`}>
      {/* <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" /> */}
      <input
        type="text"
        name="order-search"
        value={searchTerm}
        onChange={(e) => handleSearch(e.target.value)}
        placeholder="Search by Name, Phone, Order ID, Bill No..."
        className={`w-full px-3 py-2.5 pr-3 border rounded-md focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} placeholder-gray-400 text-sm text-black bg-white`}
      />

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
      />
    </div>
  );
};

export default SearchField;
